export default "/048cb1f2b29308e18768c65cfd51e426596a830c/3fadfda14f341399d663fd2ed398d959.svg";